import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ipm-empty-data-message',
  templateUrl: './empty-data-message.component.html',
  styleUrls: ['./empty-data-message.component.scss']
})
export class EmptyDataMessageComponent implements OnInit {
  @Input() emptyMessage: string = 'Data is not available!'; 
  @Input() subMessage: string = ''; 
  @Input() isShowButton: boolean = false; 
  @Input() buttonName: string = '' 
  @Input() redirectTo: string = '';
  @Input() messageType: string = "";
  @Input() isShowIcon: boolean = true;
  @Output() onButtonClick = new EventEmitter<void>();
  isShowEmptyFirstImage: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    let currentUrl: string = this.router.url;
    if (currentUrl.includes('cart')) {
      this.isShowEmptyFirstImage = true;
    }
  }

  /**
   * Redirect to Particular page 
   */
  gotoPageName() {
    this.onButtonClick.emit();
    this.router.navigate([this.redirectTo]);
  }
}
